import { type UseMutationOptions, useMutation } from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import type { AddCuratedTravelItineraryPayload } from '../../types/api/payload/curatedTravel'
import type { UpdateCuratedTravelItinerarySuccessResponse } from '../../types/api/response/curatedTravel'
import { axiosInstance } from '@/modules/Core/plugins/axios'

export const MUTATION_KEY = 'update-curated-travel-itinerary'
export const ENDPOINT = '/influencer/Itinerary/UpdateItinerary'

export function updateCuratedTravelItinerary(
  payload: AddCuratedTravelItineraryPayload
) {
  return axiosInstance.post<UpdateCuratedTravelItinerarySuccessResponse>(
    ENDPOINT,
    payload
  )
}

export function useUpdateCuratedTravelItineraryMutation(
  options?: UseMutationOptions<
    AxiosResponse<UpdateCuratedTravelItinerarySuccessResponse>,
    AxiosCustomError,
    AddCuratedTravelItineraryPayload,
    any
  >
) {
  return useMutation({
    mutationKey: [MUTATION_KEY],
    mutationFn: updateCuratedTravelItinerary,
    ...options,
  })
}
